import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS Private Cloud
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          Ihre eigene Private Cloud-Infrastruktur mit maximaler Kontrolle, Sicherheit
          und Flexibilität. Ideal für Unternehmen mit hohen Anforderungen an
          Datenschutz und Performance.
        </SoftTypography>
      </SoftBox>

      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Infrastruktur
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Frei skalierbarer RAM-Pool <br />
              - Flexibler Storage-Pool mit NVMe SSDs <br />
              - Dedizierte CPU-Ressourcen <br />
              - Proxmox VE Hypervisor <br />
              - Optionale dedizierte Hardware
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Sicherheit & Compliance
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - ISO 27001 zertifizierte Rechenzentren <br />
              - DSGVO-konform <br />
              - Physisch isolierte Ressourcen <br />
              - Mehrstufiges Backup-System <br />
              - 24/7 Security-Monitoring
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              High Availability
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Redundante Infrastruktur <br />
              - Automatisches Failover <br />
              - Multi-Zone Deployment <br />
              - 99,99% Verfügbarkeit <br />
              - Load Balancing inklusive
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Management
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Direkter Proxmox Root Zugang <br />
              - Self-Service Portal <br />
              - API-Zugriff <br />
              - Detailliertes Monitoring <br />
              - Expertenberatung & Support
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>

      <SoftBox mt={4} textAlign="center">
        <SoftButton color="info" onClick={onNext}>
          Private Cloud jetzt konfigurieren
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default About;